function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { RowLabelType, SelectorTypeDefinitions } from "common/query-builder/query-entry-section/types";
import { StringOperator } from "common/widgets/property-filter-menu/models/types";
import { QueryEntrySectionEl } from "common/query-builder/query-entry-section/panel";
import { getProjectId, getWorkspaceId } from "common/report/util";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import nonOverlappingSegmentsImg from "common/assets/images/custom-groups/nonoverlapping-segments.svg";
export function template() {
  const segment = this.params.segment;
  const listProperty = this.params.listProperty;
  const filters = this.getFilters();
  const commonEntryParams = {
    filters: [],
    filterOnly: true,
    hideListQuantifier: true,
    quickDelete: true,
    suppressTracking: true,
    type: SelectorTypeDefinitions.Filter,
    event: this.createTemplateFilter(segment).getAttributes()
  };
  const placeholderRow = _objectSpread(_objectSpread({}, commonEntryParams), {}, {
    quickDelete: false,
    operatorOverrides: this.getFilterOperatorOverrides(filters.length)
  });
  const disableFilterSection = filters.length >= 10;
  return /* @__PURE__ */ jsx("div", { sel: ".mp-string-bucket-pane", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".input-area" }, /* @__PURE__ */ jsx(
    QueryEntrySectionEl,
    {
      containedSection: true,
      indentFilters: true,
      disableAddEntry: true,
      disabled: disableFilterSection,
      rowIndex: 0,
      rowLabelType: RowLabelType.None,
      addEntryButtonLabel: "Select Value",
      entries: [...filters.map((event, idx) => _objectSpread(_objectSpread({}, commonEntryParams), {}, {
        event,
        quickRename: event.filterOperator === StringOperator.Equals,
        operatorOverrides: this.getFilterOperatorOverrides(idx)
      })), placeholderRow],
      eventNames: this.params.eventNames,
      projectId: parseInt(getProjectId()),
      workspaceId: parseInt(getWorkspaceId()),
      rowTypes: [{
        placeholderEntry: commonEntryParams,
        value: SelectorTypeDefinitions.Filter
      }],
      trackProperties: {
        sectionName: "customize-string-group"
      },
      onUpdate: (updates) => this.handleFiltersUpdate(updates),
      onKeyUp: (ev) => ev.stopPropagation(),
      ...listProperty ? {
        listProperty
      } : {},
      "data-sentry-element": "QueryEntrySectionEl",
      "data-sentry-source-file": "template.tsx"
    }
  ), /* @__PURE__ */ jsx("div", { sel: ".remaining-values" }, /* @__PURE__ */ jsx("span", null, this.t("query-builder.buckets.else-remaining")), /* @__PURE__ */ jsx("div", { sel: ".help-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info-xs"
  }, "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    "image-src": nonOverlappingSegmentsImg,
    "max-width": "150px",
    placement: Placement.RightCenter,
    text: this.t("query-builder.buckets.remaining-tooltip")
  }, "data-sentry-element": "TooltipEl", "data-sentry-source-file": "template.tsx" })))));
}
